import React from 'react';
import { IconButton as StyledIconButton } from './IconButton.styled';

export interface IconButtonProps {
  children: React.ReactNode;
  onClick?: () => void;
  className?: string;
  disabled?: boolean;
  loading?: boolean;
}

export function IconButton({ 
  children, 
  onClick, 
  className, 
  disabled,
  loading
}: IconButtonProps) {
  return (
    <StyledIconButton
      onClick={onClick}
      className={className}
      disabled={disabled}
      loading={loading}
    >
      {children}
    </StyledIconButton>
  );
}
